import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=7da44a98&scoped=true&"
import script from "./serviceAgreement.vue?vue&type=script&lang=js&"
export * from "./serviceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./serviceAgreement.vue?vue&type=style&index=0&id=7da44a98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da44a98",
  null
  
)

export default component.exports